import { Api } from 'models/services/api';
import { ReadFranchisorsQuery } from 'models/services/graphql';

import { FranchisorCollectionData } from '../collection';

type DataToFetch = {
  organizationId: string;
  nextToken?: string;
};

const RequestQuery = `
  query ReadFranchisors($organizationId: ID!, $nextToken: String) {
    ${ReadFranchisorsQuery}
  }
`;

type ResponseData = {
  data: {
    readFranchisors: FranchisorCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: FranchisorCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readFranchisors;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };
